/**
 * 描述：单位维护接口管理
 * 录入人： 昂少强
 */
import request from '../request.js'

/**
* 描述：单位类型树查询
* 接口管理员：郑志会
* 参数： 
{
}
*/
export const getLimits = function (data) {
    return request({
        url: 'sysLimit/getLimits',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: true
        },
    })
}


/**
* 描述：单位选择器数据
* 接口管理员：郑志会
* 参数： 
{
    tenantId:'', // 租户id
    type:1,        // 写死
}
*/
export const getUnitList = function (data) {
    return request({
        url: 'sysTenant/getCoorperateUnits',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: true
        },
    })
}

/**
* 描述：新增或修改单位
* 接口管理员：郑志会
* 参数： 
{
     "sname": "",企业名称,
      "creditCode": "", -- - 统一社会信用代码 ,
      "unitType": "", -- --单位类型（ 码表） ,
      "address": "", -- - 单位地址,
      "unitLinker": "", -- --联系人,
      "contract": "", -- --联系方式 ,
      "tenantId": , -- --租户ID ,
      "unitNature": "", -- -- -- - 单位性质（ 码表）,
      "remark": ""-- - 备注
}
*/
export const saveCoorperateUnit = function (data) {
    return request({
        url: 'auditUnits/newCooperationUnit',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: true
        },
    })
}

/**
* 描述：查询单位列表数据
* 接口管理员：郑志会
* 参数： 
{
    "tenantId": , -- --租户ID
    "size": 10,
    "current": 1,
    "limitId": ""-- --单位类型（ 码表）
    "sname": "", -- -- - 企业名称
}
*/
export const selectPagaUnits = function (data) {
    return request({
        url: 'sysTenantDetail/selectPagaTenantDetails',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: true
        },
    })
}

/**
* 描述：删除单位
* 接口管理员：郑志会
* 参数： 
{
      "id": ""-- - 单位主键
}
*/
export const delUnit = function (data) {
    return request({
        url: 'auditUnits/deleteId ',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: true
        },
    })
}